// extracted by mini-css-extract-plugin
export var loadingSpinner = "_27-0";